import {
  TyrianApp
} from './target/scala-3.6.2/agoraweb-fastopt/main.js';

TyrianApp.launch("myapp");
